import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const sliderVertical = () => {

    const sliders = document.querySelectorAll('.c-slider--vertical');
    if(!sliders) return;

    sliders.forEach(slider => {
        const slideNumber = slider.querySelector('.c-slider__current');
        const prevArrow = slider.querySelector('.c-slider-arrow--prev');
        const nextArrow = slider.querySelector('.c-slider-arrow--next');

        const swiper = new Swiper(slider, {
            modules: [ Navigation ],
            simulateTouch: false,
            autoHeight: true,
            speed: 1000,
            slidesPerView: 1,
            spaceBetween: 64,
            navigation: {
                prevEl: prevArrow,
                nextEl: nextArrow
            },
            breakpoints: {
                1024: {
                    direction: 'vertical',
                    spaceBetween: 0
                }
            }
        });

        swiper.on('slideChange', () => {
            let currentSlide = swiper.realIndex + 1;
            slideNumber.innerHTML = currentSlide;
        });
    });

}

export { sliderVertical }